export enum SyncStatus {
  Pending = 'Pending',
  CurrentlyRunning = 'CurrentlyRunning',
  Failed = 'Failed',
  Completed = 'Completed',
}
